import React, { useEffect, useState, lazy } from 'react';
import { HeartIcon, ShieldIcon, SparklesIcon, LeafIcon, BrainIcon } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function GutBenefitsSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const headerReveal = useScrollReveal({
    threshold: 0.2
  });
  const imageReveal = useScrollReveal({
    threshold: 0.2
  });
  const benefitsReveal = useScrollReveal({
    threshold: 0.1
  });
  const benefits = [{
    icon: <HeartIcon className="w-6 h-6" data-id="element-165" />,
    title: 'Fast-Acting Calm',
    description: "Safranal, saffron's most potent compound has been clinically shown to reduce stress response within 30 minutes of a single dose.*"
  }, {
    icon: <BrainIcon className="w-6 h-6" data-id="element-166" />,
    title: ' Three Compounds. One Circuit. ',
    description: 'Crocin, safranal & crocetin work together to support the calm-focus-regulate system that breaks down when your brain feels scattered.'
  }, {
    icon: <LeafIcon className="w-6 h-6" data-id="element-167" />,
    title: 'No Stimulants. No Crashes.',
    description: 'Unlike Adderall or caffeine, this is gentle daily support — no jitters, no dependency, no conflict with your faith.'
  }, {
    icon: <SparklesIcon className="w-6 h-6" data-id="element-168" />,
    title: '77% Feel the Shift by Day 15',
    description: 'In clinical studies, 3 out of 4 people reported improved emotional balance and optimism within just two weeks.'
  }];
  useEffect(() => {
    if (!isAutoPlaying) return;
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % benefits.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [isAutoPlaying, benefits.length]);
  const goToSlide = index => {
    setCurrentSlide(index);
    setIsAutoPlaying(false);
  };
  return <section className="w-full bg-[#f5f1ed] py-16 lg:py-24" data-id="element-169">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-170">
        {/* Section Header */}
        <div ref={headerReveal.ref} className={`text-center mb-12 transition-all duration-1000 ${headerReveal.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-171">
          <h2 className="font-serif text-3xl lg:text-4xl font-bold text-[#2d4a3a] mb-4" data-id="element-172">
            God Already Created the Answer.
          </h2>
          <p className="text-gray-600 text-xs max-w-2xl mx-auto mb-6" data-id="element-173">
            The biblical botanical with 3 active compounds clinically shown to support calm, focus &
            emotional steadiness in as little as 30 minutes.
          </p>
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 items-center" data-id="element-174">
          {/* Left Image */}
          <div ref={imageReveal.ref} className={`order-1 lg:order-1 transition-all duration-1000 ${imageReveal.isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'}`} data-id="element-175">
            <div className="relative" data-id="element-176">
              <img src="https://cdn.shopify.com/s/files/1/0637/8940/0115/files/a629fde7-2dd6-4138-b3f0-f44b81b3b251.png?v=1764131773" alt="Faith & Fig Divine Wellness Product" className="w-full max-w-md mx-auto rounded-2xl shadow-xl transform hover:scale-105 transition-transform duration-300" data-id="element-177" />

              <div className="absolute -top-4 -right-4 bg-[#496f58] text-white rounded-full w-24 h-24 flex flex-col items-center justify-center shadow-xl animate-bounce" data-id="element-178">
                <span className="text-2xl font-bold" data-id="element-179">90%</span>
                <span className="text-[8px] text-center leading-tight" data-id="element-180">Feel Better</span>
              </div>
            </div>
          </div>

          {/* Right Slideshow */}
          <div ref={benefitsReveal.ref} className="order-2 lg:order-2" data-id="element-181">
            <div className="relative min-h-[140px] mb-4" data-id="element-182">
              {benefits.map((benefit, index) => <div key={index} className={`absolute inset-0 transition-all duration-700 ${index === currentSlide ? 'opacity-100 translate-x-0 pointer-events-auto' : 'opacity-0 translate-x-12 pointer-events-none'}`} data-id="element-183">
                  <div className="flex items-start gap-4 group" data-id="element-184">
                    <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#496f58] text-white flex items-center justify-center group-hover:scale-110 transition-transform" data-id="element-185">
                      {benefit.icon}
                    </div>
                    <div data-id="element-186">
                      <h3 className="font-bold text-lg text-[#2d4a3a] mb-2" data-id="element-187">{benefit.title}</h3>
                      <p className="text-gray-600 leading-relaxed" data-id="element-188">{benefit.description}</p>
                    </div>
                  </div>
                </div>)}
            </div>

            {/* CTA BUTTON */}
            <div className="flex justify-center pt-2" data-id="element-189">
              
            </div>
          </div>
        </div>
      </div>
    </section>;
}